import { defineStore } from 'pinia'
import { isHttp, routePathToName } from '@/common/utils/common'
import router from '@/router'
import { LocationQuery, RouteRecordName } from 'vue-router'

export type TabState = {
    tabList: Tab[]
    activeKey: string
    // defaultActive: string
    openeds: string[]
    activeTab: Tab
}

export type Tab = {
    key: string
    title: string
    closable?: boolean
    icon?: Function
    path?: string
    query?: LocationQuery
    // 组件路径
    componentPath?: string
    // 是否新窗口打开
    isOpenNewWindow?: boolean
}

export const useTabStore = defineStore('tab', {
    state: (): TabState => {
        return {
            tabList: [],
            activeKey: routePathToName('/office/workbench/index'),
            openeds: [routePathToName('/office/index')],
            activeTab: {
                key: '',
                title: '',
            },
        }
    },
    actions: {
        getActiveTab(activeKey?: string) {
            if (activeKey) {
                return this.tabList.find(tab => tab.key === activeKey)
            } else {
                return this.tabList.find(tab => tab.key === this.activeKey)
            }
        },
        /**
         * 设置 activeKey
         * @param key
         */
        setActiveKey(key: RouteRecordName | string | null | undefined) {
            if (!key) {
                return
            }
            this.activeKey = key as string
        },
        setOpeneds(opends: string[]) {
            this.openeds = opends
        },
        /**
         * 添加 tab
         * @param tab
         * @param pushRoute
         */
        async addTab(tab: Tab, pushRoute: boolean) {
            if (isHttp(tab.path)) {
                pushRoute = false
            }
            let tabList: Tab[] = this.tabList
            if (!tabList) {
                tabList = []
            }
            if (tabList.length > 1) {
                tabList.forEach(tempTab => {
                    tempTab.closable = true
                })
                this.tabList = tabList
            } else {
                tabList.forEach(tempTab => {
                    tempTab.closable = false
                })
                this.tabList = tabList
            }
            const activeTab = tabList.find(tempTab => tempTab.key === tab.key)
            // console.log(activeTab)
            if (activeTab) {
                this.activeKey = activeTab.key
                this.activeTab = activeTab
                if (pushRoute) {
                    await router.push({
                        name: this.activeKey,
                        query: tab.query,
                    })
                    return
                }
                return
            }

            tabList.push({
                key: tab.key,
                title: tab.title,
                closable: tab.closable,
                path: tab.path,
            })

            if (tabList.length > 1) {
                tabList.forEach(tempTab => {
                    tempTab.closable = true
                })
                this.tabList = tabList
            } else {
                tabList.forEach(tempTab => {
                    tempTab.closable = false
                })
                this.tabList = tabList
            }
            this.activeKey = tab.key
            this.activeTab = tab
            if (pushRoute) {
                await router.push({ name: this.activeKey, query: tab.query })
            }
        },
        /**
         * 删除 tab
         * @param tabKey
         */
        async removeTab(tabKey: string) {
            const tabList = this.tabList
            if (tabList.length <= 1) {
                ElMessage.warning('最后一个标签页不能关闭')
                return
            }
            const index = tabList.findIndex(tab => tab.key === tabKey)
            if (tabKey === this.activeKey) {
                const leftIndex = index - 1
                const rightIndex = index + 1
                const rightTab = this.tabList[rightIndex]
                if (rightTab) {
                    this.activeKey = rightTab.key
                    await router.push({ name: this.activeKey })
                } else {
                    const leftTab = this.tabList[leftIndex]
                    if (leftTab) {
                        this.activeKey = leftTab.key
                        await router.push({ name: this.activeKey })
                    }
                }
            }
            this.tabList.splice(index, 1)
            if (this.tabList.length === 1) {
                this.tabList.forEach(tempTab => {
                    tempTab.closable = false
                })
            }
        },
        /**
         * 设置 tabList
         * @param tabList
         */
        async setTabList(tabList: Tab[]) {
            this.tabList = tabList
        },
        async refreshCurrentTab() {
            console.log(this.activeKey)
            await router.replace({
                name: this.activeKey,
                query: {
                    t: Date.now(),
                },
            })
        },
        async closeOtherTab() {
            this.tabList = this.tabList.filter(tab => tab.key === this.activeKey)
            this.tabList.forEach(tempTab => {
                tempTab.closable = false
            })
        },
        reset() {
            this.$reset()
        },
        clear() {
            sessionStorage.removeItem('tab')
        }
    },
    persist: {
        storage: sessionStorage,
    },
})
